import React, { useMemo } from 'react'
import { rankWith, scopeEndsWith } from '@jsonforms/core'
import { withJsonFormsControlProps } from '@jsonforms/react'
import { JsonForms } from '@jsonforms/react'
import { materialCells } from '@jsonforms/material-renderers'
import DropWrapper from 'designer/component/system/layout/control/DropWrapper'

import { createSystemRenderer } from 'designer/component/control/renderer'

export const ModalBody = (props) => {
  let { data, schema, uischema } = props

  const renderers = useMemo(
    () => createSystemRenderer(uischema.elements),
    [JSON.stringify(uischema.elements)]
  )

  return (
    <DropWrapper {...props}>
      <p
        className="position-absolute d-flex align-items-end m-0"
        style={{ top: '5px' }}
      >
        ออกแบบ Modal Body
      </p>
      <JsonForms
        schema={schema}
        uischema={uischema}
        data={data}
        renderers={renderers}
        cells={materialCells}
      />
    </DropWrapper>
  )
}

export const modalBodyTester = rankWith(3, scopeEndsWith('modalBody'))

export const modalBody = {
  tester: modalBodyTester,
  renderer: withJsonFormsControlProps(ModalBody),
}
